import { render, staticRenderFns } from "./MobileShixun.vue?vue&type=template&id=5ad44334&scoped=true&"
import script from "./MobileShixun.vue?vue&type=script&lang=js&"
export * from "./MobileShixun.vue?vue&type=script&lang=js&"
import style0 from "./MobileShixun.vue?vue&type=style&index=0&id=5ad44334&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad44334",
  null
  
)

export default component.exports